module.exports = __webpack_public_path__ + "img/s2-leaf.00ba2e2f.png";